import React from 'react'
import { Box } from '../../components/elements'
const DonationFail = () => {
  return <Box>There was a problem with the donation procress.</Box>
}
export { DonationFail }
